<template>
  <div>
    <BaseAlert v-if="isValidStatus" type="info" class="flex justify-between items-center mb-5">
      <InformationCircleIcon class="hidden sm:block w-10 h-10 mr-4 m-0 shrink-0" />
      <div>
        <h4 class="text-inherit m-0">{{ title }}</h4>
        <p class="m-0">{{ body }}</p>
      </div>
    </BaseAlert>
    <slot v-else ></slot>
  </div>
</template>

<script>
import statusDescriptions from '@/utilities/status-descriptions';
import BaseAlert from '@/components/BaseAlert.vue';
import InformationCircleIcon from '@/components/Icons/InformationCircleIcon.vue';

export default {
  name: 'statusInformation',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  components: {
    BaseAlert,
    InformationCircleIcon
  },

  computed: {
    isValidStatus() {
      return !!statusDescriptions[this.status]
    },

    title() {
      return statusDescriptions[this.status].title
    },

    body() {
      return statusDescriptions[this.status].body
    }
  }
}
</script>
